
import { InjectionToken } from '@angular/core';

import { CoinFacade } from './coin.facade';

export const COIN_FACADE = new InjectionToken<CoinFacade>('COIN_FACADE');